module.exports = __webpack_public_path__ + "images/revo-7720c57e9daa364df7c51e924e5a8bd9.jpg";